// Material Dashboard 2 PRO React base styles
import typography from "assets/theme/base/typography";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(16)} ${pxToRem(24)}`,
      fontSize: size.xl,
      fontWeight: 600,
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
  },
};

export default dialogTitle;
